import angular from 'angular'

// components
import loaderOverlay from './component/loaderOverlay.js'

export default angular
  .module('portalApp.loaderOverlay', [])
  .component('loaderOverlay', loaderOverlay)
  .name
